import { useEffect, useRef } from 'react'
import { sendResize } from '../_lib/postMessage'

/**
 * Hook to automatically resize the iframe based on content height
 */
export function useAutoResize(enabled: boolean = true) {
  const observerRef = useRef<ResizeObserver | null>(null)

  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return

    const sendCurrentHeight = () => {
      const height = document.documentElement.scrollHeight
      sendResize(height)
    }

    // Send initial height
    sendCurrentHeight()

    // Observe body size changes
    observerRef.current = new ResizeObserver(() => {
      sendCurrentHeight()
    })

    if (document.body) {
      observerRef.current.observe(document.body)
    }

    // Also send on window resize
    window.addEventListener('resize', sendCurrentHeight)

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect()
      }
      window.removeEventListener('resize', sendCurrentHeight)
    }
  }, [enabled])
}
